import React from 'react';

import Card from '../../shared/components/UIElements/Card';
//import SharedFileItem from './SharedFileItem';
import GetSharedFileItem from './GetSharedFileItem';
//import Button from '../../shared/components/FormElements/Button';
import './SharedFileList.css';

//import { useAuth } from '../../shared/hooks/auth-hook';

const GetSharedFileList = props => {
    //const { userId } = useAuth();
    
    if (props.items.length === 0) {
        return (
            <div className = "place-list place-list--empty">
                <Card>
                    <h2> No files found. </h2>
                    
                    {/*<Button to="/files/new"> Files Upload </Button>*/}
                    {/*<Button to={`/${userId}/files`}> My Files </Button>*/}
                    
                </Card>        
            </div>
        );
    }

    return (
        <ul className = "place-list">
            {props.items.map (file => (
                <GetSharedFileItem
                    key = {file.id}
                    id = {file.id}
                    image={file.image}
                    //title={place.title}
                    mimeType={file.mimeType} // Added this for the pdf files
                    originalName={file.originalName} // Added this for the pdf files
                    //description={place.description}
                    //address={place.address}
                    creatorId={file.creator}
                    //coordinates={place.location}
                    onDelete={props.onDeleteFile}
                />
            ))}
        </ul>
    );

};

export default GetSharedFileList;